import React from 'react';

import type { CircleProps } from '@/components/stepper/types';

export function Circle({ status, onClick, tabIndex }: CircleProps) {
  const getColor = (): { bg: string; border: string } => {
    switch (status) {
      case 'current':
        return {
          bg: 'bg-blue',
          border: 'border border-blue',
        };
      case 'completed':
        return {
          bg: 'bg-blue',
          border: '',
        };
      default:
        return {
          bg: 'bg-gray-300',
          border: '',
        };
    }
  };

  return (
    <div
      tabIndex={tabIndex}
      aria-label="Step"
      onClick={onClick ? onClick : undefined}
      onKeyDown={onClick ? onClick : undefined}
      className={`relative inset-0 size-4 rounded-full ${getColor().border}`}
    >
      <div className={`absolute inset-1 rounded-full ${getColor().bg}`} />
    </div>
  );
}
